import type { FormRule } from 'antd';
import type { TWarehouseTaskStatus } from 'api/swagger';
import type { IWhTaskStatusFormFields } from './types';

export const ALLOWED_FLOW_STATUS: Record<TWarehouseTaskStatus, TWarehouseTaskStatus[]> = {
  waiting: ['progress', 'cancelled'],
  progress: ['waiting', 'done'],
  done: [],
  cancelled: ['waiting'],
};

export const validationRules: Record<keyof IWhTaskStatusFormFields, FormRule[]> = {
  status: [{ required: true, type: 'string' }],
};
